const items = [
  "INDEPENDENT PRINTER SUPPORT",
  "NOT AFFILIATED WITH CANON INC.",
  "FAST SAME-DAY SERVICE",
  "REMOTE & ON-SITE OPTIONS",
  "WI-FI & DRIVER RECOVERY",
];

export default function Marquee() {
  return (
    <div data-testid="marquee-bar" className="bg-poster-ink text-white py-3 overflow-hidden border-y border-slate-700">
      <div className="mq-track gap-8 text-xs font-mono-lbl uppercase tracking-widest font-bold text-sky-300">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-8 whitespace-nowrap">
            {items.map((item) => (
              <span key={`${half}-${item}`}>&#9632; {item}</span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
